import { PropsWithChildren, FC } from 'react'

import styles from '../styles.css'

type SalesOrderInfoType = {
    title: string
}
export const SalesOrderInfo: FC<
    PropsWithChildren<SalesOrderInfoType>
> = props => {
    const { title, children } = props

    return (
        <div>
            <div className={styles.orderInfoTitle}>{title}</div>
            <div>{children}</div>
        </div>
    )
}
